// The thirteen holiday themes and the one thing the app adds to the design's engine: which theme
// name and which variant (`dv`) each theme calls `holV` with (Handoff section 2). `none` is not a
// theme, it is the absence of one — `holV('None', ...)` returns the no-theme result. Which theme
// plays on a given day is `schedule.ts`.

export const NONE_THEME_ID = 'none' as const;

/** The name `holV` does not know, so it returns the no-theme result. */
const NONE_DESIGN_NAME = 'None';

interface ThemeDesign {
  /** The design source's theme name; the key `holV` uses. */
  designName: string;
  /** Variant passed as `holV`'s `dv`: A everywhere except Nowruz (B); Chinese New Year passes none. */
  dv: 'A' | 'B' | undefined;
}

const THEMES = {
  winter: { designName: 'Winter holidays', dv: 'A' },
  chineseNewYear: { designName: 'Chinese New Year', dv: undefined },
  eid: { designName: 'Eid', dv: 'A' },
  diwali: { designName: 'Diwali', dv: 'A' },
  halloween: { designName: 'Halloween', dv: 'A' },
  thanksgiving: { designName: 'Thanksgiving', dv: 'A' },
  nowruz: { designName: 'Nowruz', dv: 'B' },
  earthDay: { designName: 'Earth Day', dv: 'A' },
  pride: { designName: 'Pride Month', dv: 'A' },
  womensDay: { designName: 'International Women’s Day', dv: 'A' },
  valentines: { designName: 'Valentine’s Day', dv: 'A' },
  mothersDay: { designName: 'Mother’s Day', dv: 'A' },
  fathersDay: { designName: 'Father’s Day', dv: 'A' },
} as const satisfies Record<string, ThemeDesign>;

export type HolidayThemeId = keyof typeof THEMES | typeof NONE_THEME_ID;

/** Registry order, `none` last. It breaks a tie between equal-width schedule windows. */
export const HOLIDAY_THEME_ORDER: readonly HolidayThemeId[] = [...(Object.keys(THEMES) as (keyof typeof THEMES)[]), NONE_THEME_ID];

/** The `holV` arguments for an id: the design name and `dv` (None maps to a name `holV` does not know). */
export function holidayDesign(id: HolidayThemeId): ThemeDesign {
  if (id === NONE_THEME_ID) return { designName: NONE_DESIGN_NAME, dv: undefined };
  return THEMES[id];
}
